export const getStatus = (t) => {
    return {0: t('status.draft'), 1: t('status.pending'), 2: t('status.rejected'), 3: t('status.accepted')};
}

export const showAdminPanel = (user) => {
    if(!user){
        return false;
    }
    if (user.is_superuser || user.is_staff) {
        return true;
    }
    return false;
}

export const showSubscriptionPanel = (user) => {
    if(!user){
        return false;
    }
    if (user.subscription ) {
        return true;
    }
    return false;
}

export const getRouteActionType = (user, access_type) => {
 /* Access Type
   0 -> Not log in
   1 -> Log in
   2 -> Subscribe
   3 -> Super user
 */
    if(access_type === 0){
        return true;
    }

    if(access_type === 1 && user) {
        return true;
    }

    if (access_type === 2 && user && user.subscription) {
        return true;
    }

    if (access_type === 3 && user && user.is_superuser) {
        return true;
    }

    return false;

}

